export default __webpack_public_path__ + "locales/pt/About.json?hash=f4918a65a682bb6107bc6019d9dccc0f";